export const TOGGLE_LID = 'localisation/TOGGLE_LID'
export const CHECK_LOCALISATION_UPDATE =
  'localisation/CHECK_LOCALISATION_UPDATE'
export const UPDATE_LOCALISATIONS = 'localisation/UPDATE_LOCALISATIONS'
export const SET_LOCALISATIONS = 'localisation/SET_LOCALISATIONS'
